import { useQuery } from 'react-query'

import {
  NgmClusterContext,
  StatementsDatasourceResponse,
  getStatementsDatasource
} from '~/api/ngm'
import { ComputedCluster } from '~/hooks/state'

const STATEMENTS_DATASOURCE_QUERY = 'ngm-statements-datasource'

/**
 * Statement V2 is available only to the Premium-line and BYOC cluster models.
 * `isPremium` intentionally includes Premium Reserved and Essential V2. Plain
 * Essential must keep its existing Statement V1 behavior.
 */
export function isStatementV2Eligible(
  cluster?: Pick<ComputedCluster, 'computed'> | null
): boolean {
  return !!(cluster?.computed.isPremium || cluster?.computed.isByoc)
}

export function statementsDatasourceQueryKey(ctx: NgmClusterContext | null) {
  return [
    STATEMENTS_DATASOURCE_QUERY,
    ctx?.orgExternalId || '',
    ctx?.projectId || '',
    ctx?.clusterId || '',
    ctx?.provider || '',
    ctx?.region || '',
    ctx?.deployType || ''
  ] as const
}

export function isStatementV2Available(
  datasource?: StatementsDatasourceResponse
): boolean {
  return datasource?.v2_available === true
}

export function useStatementsDatasource(
  ctx: NgmClusterContext | null,
  enabled = true
) {
  const queryEnabled = enabled && !!ctx?.clusterId && !!ctx?.orgExternalId

  return useQuery<StatementsDatasourceResponse, unknown>(
    statementsDatasourceQueryKey(ctx),
    () => getStatementsDatasource(ctx!),
    {
      enabled: queryEnabled,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity
    }
  )
}
